import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import PackagingDispatchNewEditForm from '../packaging-dispatch-new-edit-form';

export default function PackagingDispatchCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new dispatch"
        links={[
          {
            name: 'Dispatch',
            href: paths.dashboard.packagingDispatch.root,
          },
          { name: 'Create a new dispatch' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingDispatchNewEditForm />
    </Container>
  );
}
